<template>
  <div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop"
    >
      <!-- Logo 头部 -->
      <div class="logo-header">
        <img src="https://www.ptty.com.cn/wap/XYWL.png" class="logo-left" />
        <label class="label-xywl">星耀未来</label>
        <label class="label-ptty">跑兔体育</label>
        <img
          src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
          class="logo-right"
        />
      </div>

      <!-- 顶部菜单 -->
      <div class="top-menu-container">
        <van-row gutter="12">
          <van-col span="6">
            <div class="menu-item" @click="navToMeNewIndex">
              <div class="menu-icon" style="background: #FFF3E0;">
                <van-icon name="medal-o" size="20" color="#FF9900" />
              </div>
              <p class="menu-text">星耀生涯榜</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="menu-item" @click="navToMeQygjIndex">
              <div class="menu-icon" style="background: #F3E5F5;">
                <van-icon name="bar-chart-o" size="20" color="#9C27B0" />
              </div>
              <p class="menu-text">成长记录</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="menu-item" @click="navToMeIndex">
              <div class="menu-icon" style="background: #E3F2FD;">
                <van-icon name="user-o" size="20" color="#2D8CF0" />
              </div>
              <p class="menu-text">个人中心</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="menu-item" @click="connectMe">
              <div class="menu-icon" style="background: #E8F5E9;">
                <van-icon name="phone-o" size="20" color="#19BE6B" />
              </div>
              <p class="menu-text">联系我们</p>
            </div>
          </van-col>
        </van-row>
      </div>

      <!-- 横条图片 - 注册年度会员 -->
      <div class="member-banner" @click="registerMember">
        <div class="member-banner-content">
          <div class="member-title">办会员 看生涯 享优惠</div>
          <div class="member-subtitle">会员可享受多权益，我们在这里等您</div>
        </div>
        <div class="member-button">立即注册</div>
        <div class="glass-effect"></div>
      </div>

      <!-- 搜索和筛选区域 -->
      <div style="padding-left: 10px;padding-right:10px;">
        <van-field
          style="margin-top:15px;margin-bottom:15px;"
          v-model="search.info"
          left-icon="search"
          center
          clearable
          label=""
          placeholder="请输入项目信息"
        >
          <template #button>
            <!-- 地区检索 -->
            <div
              @click="showCityPicker = true"
              style="float: left;padding-top: 6px;margin-right: 12px;font-weight: 600;cursor: pointer;"
            >
              <van-icon name="location-o" />
              <span>{{ selectedCity.city }}</span>
            </div>
            <van-button size="small" type="primary" @click="searchHandler">
              检索
            </van-button>
          </template>
        </van-field>

        <!-- 状态筛选按钮 -->
        <van-row>
          <van-col span="24">
            <div
              @click="onBsztSelect({ value: '' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background:
                  bsztSelectData.value.length === 0 ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value.length === 0 ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              全部
            </div>
            <div
              @click="onBsztSelect({ value: '1' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '1' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '1' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              报名中
            </div>
            <div
              @click="onBsztSelect({ value: '3' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '3' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '3' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              排赛中
            </div>
            <div
              @click="onBsztSelect({ value: '6' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '6' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '6' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              比赛中
            </div>
            <div
              @click="onBsztSelect({ value: '7' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '7' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '7' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              已完赛
            </div>
          </van-col>
        </van-row>
      </div>

      <!-- 比赛列表 -->
      <div
        class="itemContentMain"
        v-for="(item, index) in resultList"
        :key="index"
        @click="navToUrl(item.SSIDEN)"
      >
        <div
          v-if="item.FWCS > 100"
          style="position: absolute;top: 5px;left: 12px;color: rgb(118 117 117);font-size:14px;"
        >
          <van-icon name="eye-o" />
          {{ item.FWCS }}
        </div>
        <div
          style="position: absolute;right: 0px;top: 0px;"
          v-if="item.BSZT.length > 0"
        >
          <van-tag
            :type="
              item.BSZT === '1'
                ? 'primary'
                : item.BSZT === '3'
                ? 'danger'
                : item.BSZT === '6'
                ? 'warning'
                : item.BSZT === '7'
                ? 'success'
                : ''
            "
          >
            {{
              item.BSZT === "1"
                ? "报名中"
                : item.BSZT === "3"
                ? "排赛中"
                : item.BSZT === "6"
                ? "比赛中"
                : item.BSZT === "7"
                ? "比赛结束"
                : ""
            }}
          </van-tag>
        </div>
        <van-row>
          <van-col span="6">
            <van-image
              round
              width="60px"
              height="60px"
              :src="
                item.IMGURL.length > 0
                  ? item.IMGURL
                  : 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
              "
            />
            <div
              v-if="item.ISVIDIOZB === '1' || item.ISIMGZB === '1'"
              style="display: flex;align-items: center;justify-content: left;margin-top:2px;background: #fff;border: none;"
            >
              <img
                v-if="item.ISVIDIOZB === '1'"
                style="width:15px;"
                src="https://www.ptty.com.cn/wap/spZb.png"
              />
              <img
                v-if="item.ISIMGZB === '1'"
                style="width:15px;margin-left: 21px;"
                src="https://www.ptty.com.cn/wap/imgZb.png"
              />
            </div>
          </van-col>
          <van-col span="18">
            <div class="contentMainDivClass">
              <div
                style="font-size: 16px;font-weight: 800;padding-bottom: 5px;"
              >
                {{ item.SSMC }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BSQSRQ.length > 0"
              >
                比赛日期：{{ item.BSQSRQ }} 至 {{ item.BSJZRQ }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.CITYNAME.length > 0"
              >
                举办城市：{{
                  item.SFNAME === item.CITYNAME
                    ? item.CITYNAME
                    : item.SFNAME + " - " + item.CITYNAME
                }}
              </div>
              <div style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;">
                比赛地址：{{ item.CGMC }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名起始时间：{{ item.BMQSRQ }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名截止时间：{{ item.BMJZRQ }}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>

      <div
        style="text-align: center;margin-top: 15px;font-size:13px;color:rgb(104, 104, 104)"
        @click="loadingGdHandler"
        v-if="resultList.length > 0"
      >
        <span>{{ isEndPage ? "已加载全部" : "点击加载更多" }}</span>
        <van-icon name="arrow-down" v-if="!isEndPage" />
      </div>
      <van-empty description="数据不存在" v-if="resultList.length === 0" />

      <!-- 底部版权信息 -->
      <div class="footer-section">
        <div class="footer-content">
          <div class="footer-logo">
            <img
              src="https://www.ptty.com.cn/wap/logo.png?v=20250530"
              alt="跑兔体育"
            />
          </div>
          <div class="footer-copyright">
            天津跑兔体育科技有限公司©版权所有
          </div>
          <div class="footer-icp">
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >津ICP备2023005649号</a
            >
          </div>
          <div class="footer-divider"></div>
          <div class="footer-slogan">
            专业体育赛事服务平台
          </div>
        </div>
      </div>
      <div style="height:150px;width:15px;"></div>
    </van-pull-refresh>

    <!--比赛类型  开始-->
    <van-action-sheet
      v-model="qslxVisible"
      :actions="qxlxActive"
      @select="onQslxSelect"
    />
    <!--比赛类型  结束-->

    <!--比赛状态  开始-->
    <van-action-sheet
      v-model="bsztShow"
      :actions="bsztActions"
      @select="onBsztSelect"
    />
    <!--比赛状态  结束-->

    <!-- 城市选择弹窗 开始 -->
    <van-popup
      v-model="showCityPicker"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div
        style="padding: 15px; height: 100%; display: flex; flex-direction: column;"
      >
        <van-search
          v-model="citySearchValue"
          placeholder="搜索省份或城市"
          @input="onCitySearch"
          style="flex-shrink: 0;"
        />
        <div
          v-if="citySearchValue"
          style="flex: 1; overflow-y: auto; margin-top: 10px;"
        >
          <van-cell
            v-for="city in filteredCities"
            :key="city.value"
            :title="city.text"
            is-link
            @click="onCitySelect(city)"
          />
          <van-empty
            v-if="filteredCities.length === 0"
            description="未找到相关城市"
          />
        </div>
        <van-cascader
          v-else
          v-model="cascaderValue"
          title="请选择省份/城市"
          :options="cityOptions"
          @close="showCityPicker = false"
          @finish="onCascaderFinish"
          style="flex: 1;"
        />
      </div>
    </van-popup>
    <!-- 城市选择弹窗 结束 -->

    <!-- 底部导航栏 开始 -->
    <van-tabbar v-model="bottomMenuActive">
      <van-tabbar-item icon="home-o" @click="tabNavToUrl">主页</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="tabNavToUrl"
        >个人中心</van-tabbar-item
      >
    </van-tabbar>
    <!-- 底部导航栏 结束 -->

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  components: { LoadingCom },
  name: "IndexXywlNew",

  data() {
    return {
      resultList: [],
      isEndPage: false,
      isLoading: false,
      bottomMenuActive: 0,
      op: "wapGL",
      qslxVisible: false,
      qxlxActive: [
        { name: "全部", value: "" },
        { name: "羽毛球", value: "1" }
      ],
      bsztShow: false,
      bsztActions: [
        { name: "全部", value: "" },
        { name: "报名中", value: "1" },
        { name: "排赛中", value: "3" },
        { name: "比赛中", value: "6" },
        { name: "比赛结束", value: "7" }
      ],
      pageSet: {
        currentPage: 1,
        pageSize: 10,
        totalNums: 0
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        city: ""
      },
      qslxSelectData: { name: "比赛类型", value: "" },
      bsztSelectData: { name: "比赛状态", value: "" },
      // 城市选择相关
      showCityPicker: false,
      cityFieldValue: "",
      citySearchValue: "",
      cascaderValue: "",
      selectedCity: { province: "", city: "全国", value: "" },
      cityOptions: [],
      allCities: [],
      isAtTop: true // 是否在顶部
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    localStorage.setItem("routeValue", "indexXywl");
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.resultList = [];
    // 初始化城市数据
    this.initCityData();
    this.mainLoadData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    // 导航到星耀生涯榜
    navToMeNewIndex() {
      this.$router.push("/meNewIndex");
    },
    // 导航到成长记录
    navToMeQygjIndex() {
      const openIdEn = localStorage.getItem("openIdEn");
      if (!openIdEn) {
        this.$router.push("/loginIndex");
        return;
      }
      const ryInfoLocal = localStorage.getItem("ryInfo");
      if (!ryInfoLocal) {
        this.$router.push("/loginIndex");
        return;
      }
      this.$router.push("/meQygjIndex");
    },
    // 导航到个人中心
    navToMeIndex() {
      const openIdEn = localStorage.getItem("openIdEn");
      if (!openIdEn) {
        this.$router.push("/loginIndex");
        return;
      }
      const ryInfoLocal = localStorage.getItem("ryInfo");
      if (!ryInfoLocal) {
        this.$router.push("/loginIndex");
        return;
      }
      this.$router.push("/meIndex");
    },
    // 联系我们
    connectMe() {
      this.$router.push({ path: "/connectMe" });
    },
    // 注册会员
    registerMember() {
      this.$router.push("/memberBenefits");
    },
    searchHandler() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    onRefresh() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    loadingGdHandler() {
      if (this.isEndPage) {
        return;
      }
      this.pageSet.currentPage = this.pageSet.currentPage + 1;
      this.mainLoadData();
    },
    mainLoadData() {
      this.search.qslx = this.qslxSelectData.value;
      this.search.bszt = this.bsztSelectData.value;
      this.search.zhlx = "ZHTY";
      var busData = {
        pageSet: this.pageSet,
        search: this.search,
        selectedCity: this.selectedCity
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "getSsxx"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        for (var a = 0; a < data.content.length; a++) {
          this.resultList.push(data.content[a]);
        }

        if (
          data.content.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        this.isLoading = false;
      });
    },
    navToUrl(ssidEn) {
      this.$router.push({ path: "/xmIndex", query: { ssid: ssidEn } });
    },
    openQslxModal() {
      this.qslxVisible = true;
    },
    onQslxSelect(item) {
      this.pageSet.currentPage = 1;
      this.qslxSelectData = item;
      this.qslxVisible = false;
      this.resultList = [];
      this.mainLoadData();
    },
    openBsztModal() {
      this.bsztShow = true;
    },
    onBsztSelect(item) {
      this.pageSet.currentPage = 1;
      this.bsztSelectData = item;
      this.bsztShow = false;
      this.resultList = [];
      this.mainLoadData();
    },
    tabNavToUrl() {
      switch (this.bottomMenuActive) {
        case 0: {
          var routeValue = localStorage.getItem("routeValue");
          if (
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
          ) {
            this.$router.push({ path: "/" });
          } else {
            this.$router.push({ path: "/" + routeValue });
          }
          break;
        }
        case 1: {
          this.$router.push({ path: "/meIndex" });
          break;
        }
      }
    },
    // 初始化城市数据
    initCityData() {
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "getWapCityList"
        },
        busData: {}
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.cityOptions = data.content;

        // 构建扁平化的城市列表用于搜索
        this.allCities = [];
        this.cityOptions.forEach(province => {
          province.children.forEach(city => {
            this.allCities.push({
              text: `${province.text} - ${city.text}`,
              value: city.value,
              province: province.text,
              city: city.text
            });
          });
        });
      });
    },
    // 城市搜索
    onCitySearch() {
      // 搜索逻辑在计算属性中处理
    },
    // 级联选择完成
    onCascaderFinish({ selectedOptions }) {
      this.showCityPicker = false;
      if (selectedOptions.length === 2) {
        this.selectedCity = {
          province: selectedOptions[0].text,
          city: selectedOptions[1].text,
          value: selectedOptions[1].value
        };
        this.cityFieldValue = `${selectedOptions[0].text} - ${selectedOptions[1].text}`;
        this.search.city = selectedOptions[1].text;
        // 重新加载数据
        this.resultList = [];
        this.pageSet.currentPage = 1;
        this.mainLoadData();
      }
    },
    // 从搜索结果中选择城市
    onCitySelect(city) {
      this.showCityPicker = false;
      this.selectedCity = {
        province: city.province,
        city: city.city,
        value: city.value
      };
      this.cityFieldValue = `${city.province} - ${city.city}`;
      this.search.city = city.city;
      this.citySearchValue = "";
      // 重新加载数据
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    // 清除城市选择
    clearCity() {
      this.cityFieldValue = "";
      this.search.city = "";
      this.selectedCity = { province: "", city: "全国", value: "" };
      this.cascaderValue = "";
      // 重新加载数据
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    }
  },
  computed: {
    filteredCities() {
      if (!this.citySearchValue) {
        return [];
      }
      const keyword = this.citySearchValue.toLowerCase();
      return this.allCities.filter(city => {
        return (
          city.province.toLowerCase().includes(keyword) ||
          city.city.toLowerCase().includes(keyword)
        );
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Logo 头部样式 */
.logo-header {
  padding: 10px;
  background: rgb(89, 160, 189);
  text-align: left;
  font-size: 1.1rem;
  height: 2rem;
  position: relative;
  z-index: 100; /* 确保在下拉刷新指示器之上 */
}

.logo-left {
  width: 42px;
  position: absolute;
  top: 5px;
  left: 10px;
}

.label-xywl {
  position: absolute;
  left: 62px;
  top: 16px;
  font-weight: 700;
  color: #fac000;
}

.label-ptty {
  position: absolute;
  right: 58px;
  top: 13px;
  font-weight: 700;
  color: #fff;
}

.logo-right {
  position: absolute;
  width: 36px;
  right: 12px;
  top: 5px;
}

.my-button {
  position: absolute;
  right: 12px;
  top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.my-text {
  font-size: 10px;
  color: #fff;
  margin-top: 2px;
}

/* 注册年度会员横条样式 */
.member-banner {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  margin: 10px;
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.member-banner:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.member-banner:active {
  transform: translateY(0);
}

.member-banner-content {
  flex: 1;
  position: relative;
  z-index: 2;
}

.member-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}

.member-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.member-button {
  background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(243, 156, 18, 0.3);
  white-space: nowrap;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.member-banner:hover .member-button {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(243, 156, 18, 0.5);
}

/* 毛玻璃动画效果 */
.glass-effect {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 70%
  );
  animation: glassMove 3s linear infinite;
  pointer-events: none;
}

@keyframes glassMove {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* 额外的光泽效果 */
.member-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.member-banner:hover::before {
  left: 100%;
}

/* 响应式优化 */
@media (max-width: 375px) {
  .member-banner {
    padding: 14px 16px;
    margin: 8px;
  }

  .member-title {
    font-size: 15px;
  }

  .member-subtitle {
    font-size: 12px;
  }

  .member-button {
    padding: 8px 16px;
    font-size: 13px;
  }
}

/* 顶部菜单容器 */
.top-menu-container {
  background: #fff;
  margin: 10px;
  border-radius: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  z-index: 50; /* 确保在下拉刷新指示器之上 */
}

@keyframes gradientMove {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* 菜单项 */
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 4px;
  border-radius: 12px;
  position: relative;
}

.menu-item::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.menu-item:hover::before {
  opacity: 1;
}

.menu-item:active {
  transform: scale(0.95);
}

/* 菜单图标 */
.menu-icon {
  width: 36px;
  height: 36px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.menu-icon::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.menu-item:hover .menu-icon {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.menu-item:hover .menu-icon::before {
  opacity: 1;
}

.menu-item:active .menu-icon {
  transform: translateY(-2px) scale(1);
}

/* 菜单文字 */
.menu-text {
  font-size: 12px;
  color: #333;
  font-weight: 600;
  text-align: center;
  margin: 0;
  line-height: 1.4;
  transition: all 0.3s ease;
  letter-spacing: 0.3px;
}

.menu-item:hover .menu-text {
  color: #667eea;
  transform: scale(1.05);
}

/* 响应式优化 */
@media (max-width: 375px) {
  .top-menu-container {
    padding: 16px 8px 12px;
    margin: 8px;
  }

  .menu-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    margin-bottom: 8px;
  }

  .menu-text {
    font-size: 11px;
  }
}

/* 添加入场动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.top-menu-container {
  animation: fadeInUp 0.6s ease-out;
}

.menu-item:nth-child(1) {
  animation: fadeInUp 0.6s ease-out 0.1s both;
}

.menu-item:nth-child(2) {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.menu-item:nth-child(3) {
  animation: fadeInUp 0.6s ease-out 0.3s both;
}

.menu-item:nth-child(4) {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 12px;
  padding: 16px;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  overflow: hidden;
  contain: layout style paint;
  content-visibility: auto;
}
.van-image--round {
  margin-top: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 3px solid #fff;
}

.van-tag {
  font-size: 13px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.contentMainDivClass {
  padding-top: 15px;
}

/* 美化访问次数显示 */
.itemContentMain > div[style*="position: absolute"] {
  z-index: 2;
}

.itemContentMain > div[style*="left: 12px"] {
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  top: 12px !important;
  left: 16px !important;
}

/* 美化状态标签位置 */
.itemContentMain > div[style*="right: 0px"] {
  border-radius: 0 16px 0 16px;
  overflow: hidden;
}

.itemContentMain > div[style*="right: 0px"] .van-tag {
  border-radius: 0 16px 0 16px !important;
  margin: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 美化直播标签 */
.itemContentMain [style*="display: flex"] {
  background: rgba(24, 95, 155, 0.05);
  padding: 5px;
  border-radius: 12px;
  margin-top: 4px !important;
  border: 1px solid rgba(24, 95, 155, 0.1);
}

/* 响应式优化 */
@media (max-width: 768px) {
  .itemContentMain {
    margin: 8px;
    padding: 12px;
    border-radius: 12px;
  }

  .itemContentMain > div[style*="left: 12px"] {
    top: 8px !important;
    left: 12px !important;
    padding: 4px 8px;
    font-size: 12px;
  }

  .van-image--round {
    margin-top: 36px;
  }

  .footer-section {
    margin-top: 30px;
    padding: 20px 15px;
    border-radius: 15px 15px 0 0;
  }

  .footer-content {
    gap: 10px;
  }

  .footer-logo img {
    width: 35px;
    height: 35px;
  }

  .footer-copyright {
    font-size: 13px;
  }

  .footer-icp a {
    font-size: 11px;
    padding: 5px 10px;
  }

  .footer-slogan {
    font-size: 11px;
  }
}

/* 底部区域美化 */
.footer-section {
  margin-top: 40px;
  position: relative;
  overflow: hidden;
  background: #fff;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 15px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  max-width: 400px;
  margin: 0 auto;
}

.footer-logo {
  margin-bottom: 8px;
}

.footer-logo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.15);
}

.footer-copyright {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  line-height: 1.5;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-icp {
  margin-top: 4px;
}

.footer-icp a {
  font-size: 12px;
  color: #7f8c8d;
  text-decoration: none;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-block;
}

.footer-divider {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #185f9b, transparent);
  margin: 8px 0;
  border-radius: 1px;
}

.footer-slogan {
  font-size: 12px;
  color: #95a5a6;
  font-style: italic;
  opacity: 0.8;
  letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/IndexXywl.vue